import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Row, Col } from 'react-bootstrap';

import { Text, Button } from 'react-orange-ui';

import WordingService from '../../../services/WordingService';
import TagService from '../../../services/TagService';

const WithNewLine = styled(Text)`
  white-space: pre-wrap;
`;

class NoContact extends Component {
  state = {
    message: WordingService.getWording('caption', 'isNotOwnerAccount'),
    buttonLabel: WordingService.getWording('button', 'end'),
    canReceiveLetter: false,
  }; // The user is not the owner of the account so he can't reset the password

  componentDidMount() {
    this.userCanGetLetter();
  }

  /**
   * Set correct message and button when the user account can get a letter with temporary password
   */
  userCanGetLetter = () => {
    const { identities } = this.props;
    const { hasPostalAddress, accountLevel, isPro } = identities;

    if (accountLevel === 'PRINCIPAL') {
      if (isPro === '1' || hasPostalAddress !== '1') {
        this.setState({
          message: WordingService.getWording('caption', 'contactSAV'),
          buttonLabel: WordingService.getWording('button', 'end'),
          canReceiveLetter: false,
        }); // The user have to contact the client support
      } else {
        this.setState({
          message: WordingService.getWording('caption', 'getLetter'),
          buttonLabel: WordingService.getWording('button', 'getLetter'),
          canReceiveLetter: true,
        }); // The user can receive a letter
      }
    }
  };

  /**
   * Check if a letter is already pending when click on "Get letter" button
   * Quit app when click on "End" button
   * @param e
   */
  handleClick = (e) => {
    e.preventDefault();
    const { canReceiveLetter } = this.state;
    const { checkPendingLetter, quitApp } = this.props;

    if (canReceiveLetter) {
      TagService.sendAction('getLetter');
      checkPendingLetter();
    } else {
      TagService.sendAction('endLetter');
      quitApp();
    }
  };

  render() {
    const { message, buttonLabel, canReceiveLetter } = this.state;
    const id = canReceiveLetter ? 'button-get-letter' : 'button-end';

    return (
      <Row>
        <Col sm={9} xs={12}>
          <WithNewLine id="no-contact-message">
            {message}
          </WithNewLine>
          <br />
          <Button id={id} type="fill" onClick={this.handleClick}>
            {buttonLabel}
          </Button>
        </Col>
      </Row>
    );
  }
}

NoContact.propTypes = {
  identities: PropTypes.shape({
    hasPostalAddress: PropTypes.oneOf(['0', '1']),
    accountLevel: PropTypes.oneOf(['NSRU', 'MULTIBAL', 'PRINCIPAL', 'EXTERNAL']),
    isPro: PropTypes.oneOf(['0', '1']),
  }).isRequired,
  checkPendingLetter: PropTypes.func.isRequired,
  quitApp: PropTypes.func.isRequired,
};

export default NoContact;
